export const perPageOptions = [5, 10, 25];
export const defaultPerPageIndex = 1;
